import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { awsWeb } from '../web-manifest.js';
import { AwsIcon } from './icons/AwsIcon.js';

export default createWebRegistrationFromManifest(
  awsWeb,
  {
    AwsPage: () => import('./AwsPage'),
    AwsCredentialPicker: () => import('./AwsCredentialPicker'),
    AwsCredentialSummary: () => import('./AwsCredentialSummary'),
    AwsDetailSection: () => import('./AwsDetailSection'),
  },
  {
    icons: { Aws: AwsIcon },
  },
);
